import { IModel } from '../base/annotation';
import { Metamodel } from '../base/model';
import { stringIsNullOrEmpty } from '../../shared/utils/string.util';

@Metamodel.model({})
export class FilePath {

    public static readonly MODEL: IModel;

    public container: string = ''; // for Amazon S3/Amazon S3 Compatible/Google Cloud Storage

    public folderPath: string = '';

    public fileName: string = '';

    public path: string = '';

    public isFolder: boolean = false;

    public getFullPath(): string {
        if (this.path) {
            return this.path;
        }
        if (this.isFolder) {
            return [this.container, this.folderPath].filter((value) => value).join('/');
        }
        return [this.container, this.folderPath, this.fileName].filter((value) => value).join('/');
    }

    // This function doesn't work well for v1 s3 when using key because part of the folder path is inside fileName in that scenario .
    // Leave it as is since we will deprecate v1
    public getFullFolderPath(isAmazonS3: boolean = false): string {
        let folderPathInFileName = '';
        if (isAmazonS3 && !stringIsNullOrEmpty(this.fileName)) {
            if (this.fileName.endsWith('/')) {
                folderPathInFileName = this.fileName;
            } else {
                const parts = this.fileName.split('/');
                if (parts.length > 1) {
                    folderPathInFileName = parts.slice(0, parts.length - 1).join('/');
                }
            }
        }
        return [this.container, this.folderPath, folderPathInFileName].filter((value) => value).join('/');
    }
}
